/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
      'onDrawerOpen': ajaxCart.load
    });
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Cart");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();



// HAIR QUIZ




$(document).ready(function() {
  var style = "";
  var hairShine = "";
  var hairHold = "";
var skus = [
    {
      style:1, hairShine:"no-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Clay',url:'https://peteandpedro.com/collections/styling-aids/products/clay',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/CLAY_2oz_large.png?v=1572290426'},recommendation2:{name:'Pete&Pedro Cream',url:'https://peteandpedro.com/collections/styling-aids/products/cream',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Cream_2oz_large.png?v=1567614537'}
    },
    {
      style:1, hairShine:"no-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Clay',url:'https://peteandpedro.com/collections/styling-aids/products/clay',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/CLAY_2oz_large.png?v=1572290426'}
    },
    {
      style:1, hairShine:"no-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Putty',url:'https://peteandpedro.com/collections/styling-aids/products/putty',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PUTTY_2oz_3f97da47-482c-46a1-ac70-1a548cae6293_large.png?v=1567730306'}
    },
    {
      style:1, hairShine:"medium-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'},recommendation2:{name:'Pete&Pedro Cream',url:'https://peteandpedro.com/collections/styling-aids/products/cream',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Cream_2oz_large.png?v=1567614537'}
    },
    {
      style:1, hairShine:"medium-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'}
    },
    {
      style:1, hairShine:"medium-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Putty',url:'https://peteandpedro.com/collections/bueno_hair_products/products/putty',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PUTTY_2oz_3f97da47-482c-46a1-ac70-1a548cae6293_large.png?v=1567730306'}
    },
    {
      style:1, hairShine:"high-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'},recommendation2:{name:'Pete&Pedro Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/POMADE_2oz_large.png?v=1567112359'}
    },
    {
      style:1, hairShine:"high-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/POMADE_2oz_large.png?v=1567112359'}
    },
    {
      style:1, hairShine:"high-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Power Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/power-pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PowerPomade_2oz_a0873c7e-549d-44a9-8a0a-552a016809d1_large.png?v=1567112502'},recommendation2:{name:'Pete&Pedro GELous',url:'https://peteandpedro.com/collections/styling-aids/products/gelous',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/NewGELous_1_large.png?v=1567614639'}
    },
    {
      style:2, hairShine:"no-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Cream',url:'https://peteandpedro.com/collections/styling-aids/products/cream',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Cream_2oz_large.png?v=1567614537'}
    },
    {
      style:2, hairShine:"no-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'}
    },
    {
      style:2, hairShine:"no-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Putty',url:'https://peteandpedro.com/collections/styling-aids/products/putty',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PUTTY_2oz_3f97da47-482c-46a1-ac70-1a548cae6293_large.png?v=1567730306'}
    },
    {
      style:2, hairShine:"medium-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'}
    },
    {
      style:2, hairShine:"medium-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'}
    },
    {
      style:2, hairShine:"medium-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Putty',url:'https://peteandpedro.com/collections/styling-aids/products/putty',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PUTTY_2oz_3f97da47-482c-46a1-ac70-1a548cae6293_large.png?v=1567730306'}
    },
    {
      style:2, hairShine:"high-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'},recommendation2:{name:'Pete&Pedro Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/POMADE_2oz_large.png?v=1567112359'}
    },
    {
      style:2, hairShine:"high-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/POMADE_2oz_large.png?v=1567112359'}
    },
    {
      style:2, hairShine:"high-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Power Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/power-pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PowerPomade_2oz_a0873c7e-549d-44a9-8a0a-552a016809d1_large.png?v=1567112502'}
    },
    {
      style:3, hairShine:"no-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Cream',url:'https://peteandpedro.com/collections/styling-aids/products/cream',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Cream_2oz_large.png?v=1567614537'},recommendation2:{name:'Pete&Pedro SALT',url:'https://peteandpedro.com/collections/styling-aids/products/salt',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Salt300x300_large.png?v=1572289954'}
    },
    {
      style:3, hairShine:"no-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Clay',url:'https://peteandpedro.com/collections/styling-aids/products/clay',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/CLAY_2oz_large.png?v=1572290426'}
    },
    {
      style:3, hairShine:"no-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Putty',url:'https://peteandpedro.com/collections/styling-aids/products/putty',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PUTTY_2oz_3f97da47-482c-46a1-ac70-1a548cae6293_large.png?v=1567730306'}
    },
    {
      style:3, hairShine:"medium-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'},recommendation2:{name:'Pete&Pedro Cream',url:'https://peteandpedro.com/collections/styling-aids/products/cream',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Cream_2oz_large.png?v=1567614537'}
    },
    {
      style:3, hairShine:"medium-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'}
    },
    {
      style:3, hairShine:"medium-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Putty',url:'https://peteandpedro.com/collections/styling-aids/products/putty',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PUTTY_2oz_3f97da47-482c-46a1-ac70-1a548cae6293_large.png?v=1567730306'}
    },
    {
      style:3, hairShine:"high-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'},recommendation2:{name:'Pete&Pedro Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/POMADE_2oz_large.png?v=1567112359'}
    },
    {
      style:3, hairShine:"high-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/POMADE_2oz_large.png?v=1567112359'}
    },
    {
      style:3, hairShine:"high-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Power Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/power-pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PowerPomade_2oz_a0873c7e-549d-44a9-8a0a-552a016809d1_large.png?v=1567112502'}
    },
    {
      style:4, hairShine:"no-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Cream',url:'https://peteandpedro.com/collections/styling-aids/products/cream',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Cream_2oz_large.png?v=1567614537'},recommendation2:{name:'Pete&Pedro SALT',url:'https://peteandpedro.com/collections/styling-aids/products/salt',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Salt300x300_large.png?v=1572289954'}
    },
    {
      style:4, hairShine:"no-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Putty',url:'https://peteandpedro.com/collections/styling-aids/products/putty',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PUTTY_2oz_3f97da47-482c-46a1-ac70-1a548cae6293_large.png?v=1567730306'},recommendation2:{name:'Pete&Pedro Clay',url:'https://peteandpedro.com/collections/styling-aids/products/clay',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/CLAY_2oz_large.png?v=1572290426'}
    },
    {
      style:4, hairShine:"no-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Putty',url:'https://peteandpedro.com/collections/styling-aids/products/putty',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PUTTY_2oz_3f97da47-482c-46a1-ac70-1a548cae6293_large.png?v=1567730306'},
    },
    {
      style:4, hairShine:"medium-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/POMADE_2oz_large.png?v=1567112359'},recommendation2:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'}
    },
    {
      style:4, hairShine:"medium-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/POMADE_2oz_large.png?v=1567112359'},recommendation2:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'}
    },
    {
      style:4, hairShine:"medium-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Power Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/power-pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PowerPomade_2oz_a0873c7e-549d-44a9-8a0a-552a016809d1_large.png?v=1567112502'},recommendation2:{name:'Pete&Pedro Putty',url:'https://peteandpedro.com/collections/styling-aids/products/putty',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PUTTY_2oz_3f97da47-482c-46a1-ac70-1a548cae6293_large.png?v=1567730306'}
    },
    {
      style:4, hairShine:"high-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/POMADE_2oz_large.png?v=1567112359'}
    },
    {
      style:4, hairShine:"high-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/POMADE_2oz_large.png?v=1567112359'}
    },
    {
      style:4, hairShine:"high-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Power Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/power-pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PowerPomade_2oz_a0873c7e-549d-44a9-8a0a-552a016809d1_large.png?v=1567112502'}
    },
    {
      style:5, hairShine:"no-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Cream',url:'https://peteandpedro.com/collections/styling-aids/products/cream',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Cream_2oz_large.png?v=1567614537'}
    },
    {
      style:5, hairShine:"no-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Putty',url:'https://peteandpedro.com/collections/styling-aids/products/putty',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PUTTY_2oz_3f97da47-482c-46a1-ac70-1a548cae6293_large.png?v=1567730306'},recommendation2:{name:'Pete&Pedro Clay',url:'https://peteandpedro.com/collections/styling-aids/products/clay',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/CLAY_2oz_large.png?v=1572290426'}
    },
    {
      style:5, hairShine:"no-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Putty',url:'https://peteandpedro.com/collections/styling-aids/products/putty',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PUTTY_2oz_3f97da47-482c-46a1-ac70-1a548cae6293_large.png?v=1567730306'},
    },
    {
      style:5, hairShine:"medium-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Cream',url:'https://peteandpedro.com/collections/styling-aids/products/cream',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Cream_2oz_large.png?v=1567614537'},recommendation2:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'}
    },
    {
      style:5, hairShine:"medium-shine", hairHold:"medium-hold",
    recommendation1:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'},
    },
    {
      style:5, hairShine:"medium-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Putty',url:'https://peteandpedro.com/collections/styling-aids/products/putty',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PUTTY_2oz_3f97da47-482c-46a1-ac70-1a548cae6293_large.png?v=1567730306'},
    },
    {
      style:5, hairShine:"high-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/POMADE_2oz_large.png?v=1567112359'}
    },
    {
      style:5, hairShine:"high-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/POMADE_2oz_large.png?v=1567112359'}
    },
    {
      style:5, hairShine:"high-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro GELous',url:'https://peteandpedro.com/collections/styling-aids/products/gelous',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/NewGELous_1_large.png?v=1567614639'},recommendation2:{name:'Pete&Pedro Power Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/power-pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PowerPomade_2oz_a0873c7e-549d-44a9-8a0a-552a016809d1_large.png?v=1567112502'}
    },
    {
      style:6, hairShine:"no-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Cream',url:'https://peteandpedro.com/collections/styling-aids/products/cream',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Cream_2oz_large.png?v=1567614537'}
    },
    {
      style:6, hairShine:"no-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Clay',url:'https://peteandpedro.com/collections/styling-aids/products/clay',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/CLAY_2oz_large.png?v=1572290426'}
    },
    {
      style:6, hairShine:"no-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Putty',url:'https://peteandpedro.com/collections/styling-aids/products/putty',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PUTTY_2oz_3f97da47-482c-46a1-ac70-1a548cae6293_large.png?v=1567730306'},
    },
    {
      style:6, hairShine:"medium-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'}
    },
    {
      style:6, hairShine:"medium-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'}
    },
    {
      style:6, hairShine:"medium-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Putty',url:'https://peteandpedro.com/collections/styling-aids/products/putty',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PUTTY_2oz_3f97da47-482c-46a1-ac70-1a548cae6293_large.png?v=1567730306'},
    },
    {
      style:6, hairShine:"high-shine", hairHold:"low-hold",
      recommendation1:{name:'Pete&Pedro Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/POMADE_2oz_large.png?v=1567112359'},recommendation2:{name:'Pete&Pedro Paste',url:'https://peteandpedro.com/collections/styling-aids/products/paste',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/Paste_large.png?v=1567112192'}
    },
    {
      style:6, hairShine:"high-shine", hairHold:"medium-hold",
      recommendation1:{name:'Pete&Pedro Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/POMADE_2oz_large.png?v=1567112359'}
    },
    {
      style:6, hairShine:"high-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Power Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/power-pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PowerPomade_2oz_a0873c7e-549d-44a9-8a0a-552a016809d1_large.png?v=1567112502" | file_url }}'},recommendation2:{name:'Pete&Pedro GELous',url:'https://peteandpedro.com/collections/styling-aids/products/gelous',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/NewGELous_1_large.png?v=1567614639'}
    },
  	{
      scent:6, hairShine:"high-shine", hairHold:"high-hold",
      recommendation1:{name:'Pete&Pedro Power Pomade',url:'https://peteandpedro.com/collections/styling-aids/products/power-pomade',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/PowerPomade_2oz_a0873c7e-549d-44a9-8a0a-552a016809d1_large.png?v=1567112502" | file_url }}'},recommendation2:{name:'Pete&Pedro GELous',url:'https://peteandpedro.com/collections/styling-aids/products/gelous',image:'https://cdn.shopify.com/s/files/1/2384/0833/products/NewGELous_1_large.png?v=1567614639'}
    }
  ]
  const FRAG_KING = { name: 'Pete & Pedro KING', url: 'https://peteandpedro.com/collections/lifestyle/products/king-edp-cologne', image: 'https://cdn.shopify.com/s/files/1/2384/0833/products/KING_box_bottle_v1_1_2_large.jpg?v=1625163507' };
  const FRAG_REBEL = { name: 'Pete & Pedro REBEL', url: 'https://peteandpedro.com/collections/lifestyle/products/rebel-cologne', image: 'https://cdn.shopify.com/s/files/1/2384/0833/products/REBEL_box_bottle_large.jpg?v=1649449998' };
  const FRAG_SAMPLE = { name: 'Pete & Pedro Sample Set', url: 'https://peteandpedro.com/collections/lifestyle/products/fragrance-deluxe-size-samples', image: 'https://cdn.shopify.com/s/files/1/2384/0833/products/samples4_78000feb-52a7-4968-ba0f-3a1e7ff120b3_1_large.png?v=1636063620" }}' }
  const FRAG_VILLIAN = { name: 'Pete & Pedro Villain', url: 'https://peteandpedro.com/collections/lifestyle/products/villain-cologne-fragrance', image: 'https://cdn.shopify.com/s/files/1/2384/0833/products/VILLAIN_box_bottle_1_large.jpg?v=1625588727' };
  const FRAG_LEGEND = { name: 'Pete & Pedro LEGEND', url: 'https://peteandpedro.com/collections/lifestyle/products/legend-cologne-fragrance-edp', image: 'https://cdn.shopify.com/s/files/1/2384/0833/products/LEGEND_box_bottle_1_large.jpg?v=1649372248' };
  const FRAG_HERO = { name: 'Pete & Pedro HERO', url: 'https://peteandpedro.com/collections/lifestyle/products/hero-edp-cologne-1', image: 'https://cdn.shopify.com/s/files/1/2384/0833/products/HERO_box_bottle_large.jpg?v=1624606039' };
  var quiz_options = {
    "oriental":{ 
      "fall": {
        "office": { 
          "rec1": FRAG_KING,
          "rec2": FRAG_REBEL,          
          "rec3": FRAG_SAMPLE
        },
        "boys": { 
          "rec1": FRAG_VILLIAN,
          "rec2": FRAG_REBEL,
          "rec3": FRAG_SAMPLE
        },
        "date": { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_LEGEND,          
          "rec3": FRAG_SAMPLE
        },
        "formal": {         
          "rec1": FRAG_REBEL,
          "rec2": FRAG_KING,
          "rec3": FRAG_SAMPLE
        },
        "family": { 
          "rec1": FRAG_KING,
          "rec2": FRAG_REBEL,
          "rec3": FRAG_SAMPLE
        },
        "nature": { 
          "rec1": FRAG_KING,
          "rec2": FRAG_REBEL,
          "rec3": FRAG_SAMPLE
        }
      },
      "summer": {
        "boys" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_HERO,
          "rec3": FRAG_SAMPLE
        },
        "office" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_REBEL,
          "rec3": FRAG_SAMPLE
        },
        "date" : { 
          "rec1": FRAG_VILLIAN,
          "rec2": FRAG_REBEL,
          "rec3": FRAG_SAMPLE
        },
        "formal" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_LEGEND,          
          "rec3": FRAG_SAMPLE
        },
        "family" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_HERO,
          "rec3": FRAG_SAMPLE
        },
        "nature" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_LEGEND,          
          "rec3": FRAG_SAMPLE
        }
      },
      "spring": {
        "boys" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_LEGEND,          
          "rec3": FRAG_SAMPLE
        },
        "office" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_KING,
          "rec3": FRAG_SAMPLE
        },
        "date" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_LEGEND,          
          "rec3": FRAG_SAMPLE
        },
        "formal" : { 
          "rec1": FRAG_VILLIAN,
          "rec2": FRAG_REBEL,
          "rec3": FRAG_SAMPLE
        },
        "family" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_KING,
          "rec3": FRAG_SAMPLE
        },
        "nature" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_LEGEND,          
          "rec3": FRAG_SAMPLE
        }
      },
      "winter": {
        "boys" : { 
          "rec1": FRAG_VILLIAN,
          "rec2": FRAG_REBEL,
          "rec3": FRAG_SAMPLE
        },
        "office" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_REBEL,                    
          "rec3": FRAG_SAMPLE
        },
        "date" : { 
          "rec1": FRAG_VILLIAN,
          "rec2": FRAG_REBEL,
          "rec3": FRAG_SAMPLE
        },
        "formal" : { 
          "rec1": FRAG_VILLIAN,
          "rec2": FRAG_KING,
          "rec3": FRAG_SAMPLE
        },
        "family" : { 
          "rec1": FRAG_VILLIAN,
          "rec2": FRAG_REBEL,
          "rec3": FRAG_SAMPLE
        },
        "nature" : { 
          "rec1": FRAG_KING,
          "rec2": FRAG_REBEL,
          "rec3": FRAG_SAMPLE
        }
      }
    },
    "woodsy":{ 
      "fall": {
        "boys": { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_VILLIAN,
          "rec3": FRAG_SAMPLE
        },
        "office": { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_KING,
          "rec3": FRAG_SAMPLE
        },
        "date": { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_LEGEND,                    
          "rec3": FRAG_SAMPLE
        },
        "formal": { 
          "rec1": FRAG_VILLIAN,
          "rec2": FRAG_REBEL,
          "rec3": FRAG_SAMPLE
        },
        "family": { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_KING,
          "rec3": FRAG_SAMPLE
        },
        "nature": { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_HERO,
          "rec3": FRAG_SAMPLE
        }
      },
      "summer": {
        "boys" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_KING,
          "rec3": FRAG_SAMPLE
        },
        "office" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_KING,
          "rec3": FRAG_SAMPLE
        },
        "date" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_LEGEND,                    
          "rec3": FRAG_SAMPLE
        },
        "formal" : { 
          "rec1": FRAG_VILLIAN,
          "rec2": FRAG_REBEL,
          "rec3": FRAG_SAMPLE
        },
        "family" : { 
          "rec1": FRAG_KING,
          "rec2": FRAG_HERO,
          "rec3": FRAG_SAMPLE
        },
        "nature" : { 
          "rec1": FRAG_KING,
          "rec2": FRAG_HERO,
          "rec3": FRAG_SAMPLE
        }
      },
      "spring": {
        "boys" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_LEGEND,                    
          "rec3": FRAG_SAMPLE
        },
        "office" : { 
          "rec1": FRAG_KING,
          "rec2": FRAG_REBEL,                    
          "rec3": FRAG_SAMPLE
        },
        "date" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_LEGEND,                    
          "rec3": FRAG_SAMPLE
        },
        "formal" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_LEGEND,                    
          "rec3": FRAG_SAMPLE
        },
        "family" : { 
          "rec1": FRAG_KING,
          "rec2": FRAG_HERO,
          "rec3": FRAG_SAMPLE
        },
        "nature" : { 
          "rec1": FRAG_KING,
          "rec2": FRAG_HERO,
          "rec3": FRAG_SAMPLE
        }
      },
      "winter": {
        "boys" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_VILLIAN,
          "rec3": FRAG_SAMPLE
        },
        "office" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_KING,
          "rec3": FRAG_SAMPLE
        },
        "date" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_VILLIAN,
          "rec3": FRAG_SAMPLE
        },
        "formal" : { 
          "rec1": FRAG_VILLIAN,
          "rec2": FRAG_REBEL,
          "rec3": FRAG_SAMPLE
        },
        "family" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_LEGEND,
          "rec3": FRAG_SAMPLE
        },
        "nature" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_VILLIAN,
          "rec3": FRAG_SAMPLE
        }
      }
    },
    "floral":{ 
      "fall": {
        "boys": { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_REBEL,                    
          "rec3": FRAG_SAMPLE
        },
        "office": { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_KING,                    
          "rec3": FRAG_SAMPLE
        },
        "date": { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_REBEL,                    
          "rec3": FRAG_SAMPLE
        },
        "formal": { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_REBEL,                    
          "rec3": FRAG_SAMPLE
        },
        "family": { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_HERO,                    
          "rec3": FRAG_SAMPLE
        },
        "nature": { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_HERO,                    
          "rec3": FRAG_SAMPLE
        }
      },
      "summer": {
        "boys" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_REBEL,                    
          "rec3": FRAG_SAMPLE
        },
        "office" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_KING,                    
          "rec3": FRAG_SAMPLE
        },
        "date" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_KING,                    
          "rec3": FRAG_SAMPLE
        },
        "formal" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_REBEL,                    
          "rec3": FRAG_SAMPLE
        },
        "family" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_HERO,                    
          "rec3": FRAG_SAMPLE
        },
        "nature" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_HERO,                    
          "rec3": FRAG_SAMPLE
        }
      },
      "spring": {
        "boys" : { 
          "rec1": FRAG_REBEL,
          "rec2": FRAG_LEGEND,                    
          "rec3": FRAG_SAMPLE
        },
        "office" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_KING,                    
          "rec3": FRAG_SAMPLE
        },
        "date" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_KING,                    
          "rec3": FRAG_SAMPLE
        },
        "formal" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_REBEL,                    
          "rec3": FRAG_SAMPLE
        },
        "family" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_HERO,                    
          "rec3": FRAG_SAMPLE
        },
        "nature" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_HERO,                    
          "rec3": FRAG_SAMPLE
        }
      },
      "winter": {
        "boys" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_REBEL,                    
          "rec3": FRAG_SAMPLE
        },
        "office" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_KING,                    
          "rec3": FRAG_SAMPLE
        },
        "date" : { 
          "rec1": FRAG_VILLIAN,
          "rec2": FRAG_REBEL,                    
          "rec3": FRAG_SAMPLE
        },
        "formal" : { 
          "rec1": FRAG_VILLIAN,
          "rec2": FRAG_LEGEND,                    
          "rec3": FRAG_SAMPLE
        },
        "family" : { 
          "rec1": FRAG_LEGEND,
          "rec2": FRAG_HERO,                    
          "rec3": FRAG_SAMPLE
        },
        "nature" : { 
          "rec1": FRAG_VILLIAN,
          "rec2": FRAG_HERO,                    
          "rec3": FRAG_SAMPLE
        }
      }
    },
    "fresh":{ 
      "fall": {
        "boys": { 
          "rec1": FRAG_KING,
          "rec2": FRAG_HERO,                    
          "rec3": FRAG_SAMPLE
        },
        "office": { 
          "rec1": FRAG_KING,
          "rec2": FRAG_LEGEND,                    
          "rec3": FRAG_SAMPLE
        },
        "date": { 
          "rec1": FRAG_KING,
          "rec2": FRAG_REBEL,                    
          "rec3": FRAG_SAMPLE
        },
        "formal": { 
          "rec1": FRAG_KING,
          "rec2": FRAG_VILLIAN,                    
          "rec3": FRAG_SAMPLE
        },
        "family": { 
          "rec1": FRAG_KING,
          "rec2": FRAG_HERO,                    
          "rec3": FRAG_SAMPLE
        },
        "nature": { 
          "rec1": FRAG_KING,
          "rec2": FRAG_HERO,                    
          "rec3": FRAG_SAMPLE
        }
      },
      "summer": {
        "boys" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_REBEL,                    
          "rec3": FRAG_SAMPLE
        },
        "office" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_KING,                    
          "rec3": FRAG_SAMPLE
        },
        "date" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_LEGEND,                    
          "rec3": FRAG_SAMPLE
        },
        "formal" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_LEGEND,                    
          "rec3": FRAG_SAMPLE
        },
        "family" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_LEGEND,                    
          "rec3": FRAG_SAMPLE
        },
        "nature" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_KING,                    
          "rec3": FRAG_SAMPLE
        }
      },
      "spring": {
        "boys" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_KING,                    
          "rec3": FRAG_SAMPLE
        },
        "office" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_KING,                    
          "rec3": FRAG_SAMPLE
        },
        "date" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_LEGEND,                    
          "rec3": FRAG_SAMPLE
        },
        "formal" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_LEGEND,                    
          "rec3": FRAG_SAMPLE
        },
        "family" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_KING,                    
          "rec3": FRAG_SAMPLE
        },
        "nature" : { 
          "rec1": FRAG_HERO,
          "rec2": FRAG_KING,                    
          "rec3": FRAG_SAMPLE
        }
      },
      "winter": {
        "boys" : { 
          "rec1": FRAG_KING,
          "rec2": FRAG_HERO,                    
          "rec3": FRAG_SAMPLE
        },
        "office" : { 
          "rec1": FRAG_KING,
          "rec2": FRAG_LEGEND,                    
          "rec3": FRAG_SAMPLE
        },
        "date" : { 
          "rec1": FRAG_KING,
          "rec2": FRAG_REBEL,                    
          "rec3": FRAG_SAMPLE
        },
        "formal" : { 
          "rec1": FRAG_VILLIAN,
          "rec2": FRAG_KING,                    
          "rec3": FRAG_SAMPLE
        },
        "family" : { 
          "rec1": FRAG_KING,
          "rec2": FRAG_HERO,                    
          "rec3": FRAG_SAMPLE
        },
        "nature" : { 
          "rec1": FRAG_KING,
          "rec2": FRAG_HERO,                    
          "rec3": FRAG_SAMPLE
        }
      }
    },
    "stubble": {
      "daily": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        }
      },
      "weekly": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        }
      },
      "monthly": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        }
      },
      "never": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        }
      }
    },
    "short": {
      "daily": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Stubble Buddy",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/stubble-buddy-beard-vacuum-cleaner",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/StubbleBuddy_BLACK_large.jpg?v=1624035847"
            }
          }
        }
      },
      "weekly": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        }
      },
      "monthly": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          }
        }
      },
      "never": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          }
        }
      }
    },
    "medium": {
      "daily": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        }
      },
      "weekly": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        }
      },
      "monthly": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Oval Military Men's Hair & Beard Brush",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/oval-military-mens-hair-beard-brush",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/OvalBrush3_large.jpg?v=1624034832"
            }
          }
        }
      },
      "never": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          }
        }
      }
    },
    "long-thick": {
      "daily": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        }
      },
      "weekly": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Beard Care Comb & Scissors Kit",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/beard-grooming-kit",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardKit_large.png?v=1573405614"
            }
          }
        }
      },
      "monthly": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          }
        }
      },
      "never": {
        "fresh": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          }
        },
        "clean": {
          "itchiness": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "none": {
            "rec1": {
              "name": "Fresh Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/fresh-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard-Balm-Fresh_large.png?v=1567614614"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          }
        },
        "woodsy": {
          "itchiness": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "none": {
            "rec1": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec2": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          }
        },
        "tobacco": {
          "itchiness": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "beard-flakes": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "patchy-beard": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          },
          "none": {
            "rec1": {
              "name": "Rugged Beard Balm",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/woodsy-beard-balm",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BeardBalmRugged1png_large.png?v=1583726203"
            },
            "rec2": {
              "name": "Beard Oil",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/copy-of-beard-oil",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/Beard_Oil_large.png?v=1567613756"
            },
            "rec3": {
              "name": "Pocket Hair, Beard, & Mustache Double-Sided Comb",
              "url": "https:\/\/peteandpedro.com\/collections\/bueno_hair_products\/products\/double-sided-pocket-beard-mustache-hair-comb",
              "image": "https:\/\/cdn.shopify.com\/s\/files\/1\/2384\/0833\/products\/BrushComb1_large.jpg?v=1624034659"
            }
          }
        }
      }
    }
  }

  $('.advice_content_sec input').change(function(){
    var label = $(this).closest('.quiz_options').data('label');
    if (!label) {
      label = $(this).attr('name');
    }
    var getRecs = false;
    if(label == 'style'){
      style = $(this).val();
      getRecs = true;
    }
    if(label == 'hairShine'){
      hairShine = $(this).val();
      getRecs = true;
    }
    if(label == 'hairHold'){
      hairHold = $(this).val();
      getRecs = true;
    }
    if (getRecs) {
    	getRecommends();
    }
    else {
      lookupReccomends();
    }
  });

  var skulist = [];
  var option1,option2, option3;
  function lookupReccomends(){
    var quizSelected = [];
    $('.quiz_options').each(function(index, value){
      var checked = $(this).find('input:checked').length;
      var value = $(this).find('input:checked').val();
      if(checked > 0) {
        quizSelected.push(value);
      }
    })
    if ($('.quiz_options').length == quizSelected.length) {
      var recResults = quiz_options;
      $.each(quizSelected, function(index, value){
        if (recResults[value] !== undefined) {
          recResults = recResults[value];
        }
      })
      if(typeof recResults !== 'undefined') {
        $('#productlist').html('');
        
        $('#loading').hide();
        $.each(recResults, function(index, value) {
          var data = value;
          var toppick = ''
          if(index == 'rec1'){
          	var toppick = '<div class="top-item-callout"><b>TOP PICK</b></div>'
          }
          if(index == 'rec3'){
            var toppick = '<div class="top-item-callout"><b>TOP TOOL</b></div>'
            }
          
          $('#productlist').append('<div class="grid__item large--one-third medium--one-third small--one-whole item"><a class="probox" target="_blank" href="'+data.url+'"><div class="pr-image"><img src="'+data.image+'"></div><div class="pr-name">'+data.name+'</div>'+toppick+'</a></div>');
        }); 

        // Coupon
        $('#productlist').append('<div class="grid__item large--one-whole small--one-whole cupon-code"> <div class="wrapping-div" style="border: 3px solid #000; padding-left: 15px; padding-right: 15px;"> <h2 style="font-weight: 800; text-align: center; font-family: Lato; padding-top:10px; font-size:35px; margin-bottom:0;">WANT TO TRY OUR PICK?</h4> <h4 class="try-out-msg" style="text-align: center; font-family: Lato; margin-bottom:0; font-size:30px;">Get it (or anything else) For 10% Off Now<br> Click the donkey on the bottom left of the page to get the code now.</h4></div> </div>');
        $('#heid').show();
      }
    }
  }
  function getRecommends(){
    var  recommendation1;
    var  recommendation2;
    $.each(skus, function( i, obj ){
      if(obj.style == style && obj.hairShine == hairShine && obj.hairHold == hairHold){
        if(typeof obj.recommendation1 !== 'undefined'){
          recommendation1 = obj.recommendation1;
        }
        if(typeof obj.recommendation2 !== 'undefined'){
          recommendation2 = obj.recommendation2;
        }
        return;
      }
    });
    if(style != "" && hairShine != "" && hairHold != "" ){
      $('#loading').show();
      $('#productlist').empty();
      if(typeof recommendation1 === 'undefined' && typeof recommendation2 === 'undefined') {
        $('#productlist').append('<div>No Products Found</div>');
        $('#loading').hide();
      }else{
        if(typeof recommendation1 !== 'undefined') {
          var data=recommendation1;
          $('#loading').hide();
          $('#productlist').append('<div class="grid__item large--one-third medium--one-third small--one-whole item"><a class="probox" target="_blank" href="'+data.url+'"><div class="pr-image"><img src="'+data.image+'"></div><div class="pr-name">'+data.name+'</div></a></div>');
        }
        if(typeof recommendation2 !== 'undefined') {
          var data=recommendation2;
          $('#loading').hide();
          $('#productlist').append('<div class="grid__item large--one-third medium--one-third small--one-whole item"><a class="probox" target="_blank" href="'+data.url+'"><div class="pr-image"><img src="'+data.image+'"></div><div class="pr-name">'+data.name+'</div></a></div>');
        }
        if(typeof recommendation1 !== 'undefined' || typeof recommendation2 !== 'undefined') {
          $('#productlist').append('<div class="grid__item large--one-third small--one-whole cupon-code"> <div class="wrapping-div" style="border: 3px solid #000; padding-left: 15px; padding-right: 15px;"> <h4 style="font-weight: 800; text-align: center; font-family: Lato;">WANT TO TRY OUR PICK?</h4> <h4 class="try-out-msg" style="text-align: center; font-size: 35px; font-family: Lato; margin-bottom:0;">Get It</h4> <div class="condition-class" style="text-align: center; padding-top: 0; font-size: 16px; font-weight: bold; margin-top: -8px; margin-bottom: -8px;">(or anything else)</div> <h4 class="try-out-msg" style="text-align: center; font-size: 35px; font-family: Lato; margin-bottom:0;">For 10% Off Now</h4> <div style="text-align: center; font-weight: bold; padding-top: 35px; font-size: 17px;">Click the donkey on the bottom left on the page to get the code now!</div> </div> </div>');
        }
      }


      $('#heid').show();
    }else{
      $('#heid').hide();
    }
  }
});



// Initialize Timber's JS on docready
$(timber.init);

// Ingredients Info Page

$('.ingredient-title').on('click',function(){
  var index = $(this).data('tab');
  $('.ingredient-title.title-'+index+' .fa-plus').toggleClass('hidden');
  $('.ingredient-title.title-'+index+' .fa-minus').toggleClass('hidden');
  $('.ingredients-wrapper.wrapper-'+index).toggleClass('hidden');

});

// RECHARGE CANCEL BUTTON SCROLL TO TOP
$(document).ready(function() {
  $('.rc_cancel-btn').on('click', function(){
    console.log('Scrolly');
    $("html, body").animate({ scrollTop: 0 }, "slow");
  });
});





// Shampoo Hair Tool

$('.hair-type-radio').on('click', function(){
  
	$('.panel-product-list').removeClass('hidden');
  
  $('.panel-product-list .hair-type-tab').addClass('hidden');
  
  let selectVal = $(this).data('hair');
  
  console.log(selectVal);
  
$('.hair-type-tab[data-hair = '+selectVal+']').removeClass('hidden');

});







$('.step-1').parent().find('.products').slick({
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }       
  ]
});
$('.kit-builder .section-header').on('click tap', function(){
  if(!$(this).parent().hasClass('disabled')) {
    $('.kit-builder .section').removeClass('active');
    $(this).parent().addClass('active');
  }
});
$('.kit-builder .product').on('click tap', function(){
  //$(this).parent().find('.product').removeClass('selected');
  //$(this).addClass('selected');
  $(this).toggleClass('selected');
  $(this).closest('.section').find('.step-next').removeClass('disabled');
  var total = 0;
  var price = 0;
  $('.product').each(function(){
    if ($(this).hasClass('selected')) {
      price = parseInt($(this).data('price'));
      total = total+price;
    }
  })
  $('#ProductPrice1').html('$'+total);
  $('#ProductPrice1').attr('content',total);
  $('.section.review .selectedproducts ol').html('');
  $('.kit-builder .product.selected').each(function(){
    var title = $(this).find('.item-title').html();
    $('.section.review .selectedproducts ol').append('<li>'+title+'</li>');
  })
  $('.kit-process .btn-price').html('$'+total);
})
$('.step-next').on('click tap', function(){
  if(!$(this).hasClass('disabled')) {
    var current = parseInt($(this).parent().data('step'));
    var next = current+1;
    if($('.step-'+next).length > 0) {
      $('.kit-builder .section').removeClass('active');
      $('.step-'+next).parent().removeClass('disabled')
      $('.step-'+next).parent().addClass('active');
    }
    if ( $('.step-'+next).closest('.section').find('.slick-initialized').length == 0) {
      $('.step-'+next).parent().find('.products').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }       
      	]
      });
    } else {
      $('.step-'+next).parent().find('.products').slick.refresh();
    }
  }
})

$('.kit-process').on('click', function(){
  var subscription = false;
  var kitID = Math.floor(Math.random() * Math.floor(99999));
  var qty = $('#kitQTY').val();
  var kitProduct = $('#productSelect').val();
  var items = [];
  $('.kit-builder .product.selected').each(function(){
    var id = $(this).data('variant');
    var item = {'id': id,'quantity': qty,'properties':{"kitItem":kitID}};
    if (subscription) {
      item.properties['shipping_interval_frequency'] = '1';
      item.properties['shipping_interval_unit_type'] = 'Months';
    }
    items.push(item);
  })
  var mainItem = {'id': kitProduct,'quantity': qty,'properties':{"kitMain":kitID}};
  if (subscription) {
    mainItem.properties['shipping_interval_frequency'] = '1';
    mainItem.properties['shipping_interval_unit_type'] = 'Months';
  }
  var main = {'items':[mainItem]};
  
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {items},
    dataType: 'json',
    success: function() {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: main,
        dataType: 'json',
        success: function() {
          window.location.href = "/cart";
        },
          error: function(resp){ console.log(resp) }
        });
    },
    error: function(resp){ console.log(resp) }
  });
})


// Search Box Show

$('.reformed-search-icon').on('click', function(){
	$('.reformed-search-bar').toggleClass('hidden');
});


// Problem Solver Quiz

$(".question-wrapper input[class='problem']").change(function(){
  var questionData = $(this).parent().data('question');
  var answerValue = $(this).val();
  
  if(answerValue == 'yes'){
    $('.kit-wrapper .item.'+questionData).removeClass('hidden');
  }else if(answerValue == 'no'){
    $('.kit-wrapper .item.'+questionData).addClass('hidden');
  }

  var notHidden = $(".item:not('.hidden')").length;
  
  if(notHidden == 0){
    $('.no-kit-items').removeClass('hidden')
    $('.allitemsbutton').addClass('hidden')
  }else{
  	$('.no-kit-items').addClass('hidden')
    $('.allitemsbutton').removeClass('hidden')
  }
  
});

// Add System To Cart Button
$('.add-selection-to-cart').on('click', function(){
  var button = $(this);
  button.html('PROCESSING...');
  
  var add = { items: [] }
  $(".item:not('.hidden')").each(function(){
    var qty = 1;
    var id = $(this).data('variant');
    if (id) {
      add.items.push({ quantity: qty, id: id });
    }
  })
  
  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    data: add,
    success: function(response) {
      window.location.href = "/cart";
    }
  });
});

$('.new-question').on('click', function(){
  console.log('This Works');
  $(this).parent().find('.new-answer').toggleClass('hidden');
  $(this).find('.new-faq-arrow').toggleClass('flipped');
});

